<div id="navigation" [ngStyle]="{ bottom: currentView == 'flagManager' ? '50px' : '25px' }">
  <button class="btn btn-primary" (click)="toggle()" [ngClass]="{ closed: !open }">
    <i class="fa fa-th" *ngIf="!open"></i>
    <span class="close" *ngIf="open"></span>
    <div class="nav-tooltip">Navigation and additional actions</div>
  </button>
  <span class="filter-indicator" *ngIf="nActiveFilters && !open">
    {{ nActiveFilters }} filter{{ nActiveFilters > 1 ? 's' : '' }} applied
  </span>
  <div *ngIf="open">
    <div class="nav-panel" *ngIf="pannel == 'main'">
      <div class="title">
        <h3>Control tool</h3>
      </div>
      <div class="content" *ngIf="inspection">
        <div class="review-nav">
          <button
            type="button"
            [routerLink]="'/inspection/review/main/' + inspection.id"
            (click)="open = false"
            [queryParams]="{ currentImage: undefined }"
            queryParamsHandling="merge"
            title="Review"
            [ngClass]="{ active: currentView == 'main' }">
            <i class="fa fa-file-text-o"></i>
            <br />
            Review</button
          ><button
            type="button"
            [routerLink]="'/inspection/review/snapshot/' + inspection.id"
            (click)="open = false"
            queryParamsHandling="merge"
            [queryParams]="{
              currentImage: undefined,
              item: undefined,
              section: undefined,
              question: undefined,
              right: undefined
            }"
            title="Snapshot"
            [ngClass]="{ active: currentView == 'snapshot' }">
            <i class="fa fa-table"></i>
            <br />
            Snapshot</button
          ><button
            type="button"
            [routerLink]="'/inspection/review/gallery/' + inspection.id"
            (click)="open = false"
            queryParamsHandling="merge"
            [disabled]="!hasPictures"
            [queryParams]="{
              currentImage: undefined,
              item: undefined,
              section: undefined,
              question: undefined,
              right: undefined
            }"
            title="All pictures"
            [ngClass]="{ active: currentView == 'gallery' }">
            <i class="fa fa-camera"></i>
            <br />
            Gallery</button
          ><button
            type="button"
            [routerLink]="'/inspection/review/locations/' + inspection.id"
            (click)="open = false"
            queryParamsHandling="merge"
            [disabled]="!hasLocations"
            [queryParams]="{
              currentImage: undefined,
              item: undefined,
              section: undefined,
              question: undefined,
              right: undefined
            }"
            title="All locations"
            [ngClass]="{ active: currentView == 'locations' }">
            <i class="fa fa-map"></i>
            <br />
            Locations
          </button>
        </div>

        <ul class="nav-actions blue">
          <li>
            <a [routerLink]="'/inspection/form/' + inspection.id">
              <i class="fa fa-home" style="font-size: 16px"></i> Inspection Setup
            </a>
          </li>
          <li *ngIf="allowDualMonitor" (click)="dualMonitor()">
            <svg width="18" height="18" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22 13H24V2H8V4H6V1.007C6 0.451 6.455 0 6.992 0H25.008C25.556 0 26 0.449 26 1.007V13.993C26 14.549 25.545 15 25.008 15H22V13Z"
                fill="#2763CD" />
              <path
                d="M2.00004 19H18V8H2.00004V19ZM11 21V23H15V25H5.00004V23H9.00004V21H0.992041C0.860727 20.9992 0.730858 20.9725 0.609879 20.9215C0.488899 20.8704 0.379188 20.7959 0.287032 20.7024C0.194877 20.6088 0.122089 20.498 0.0728414 20.3763C0.0235937 20.2546 -0.00114581 20.1243 4.07459e-05 19.993V7.007C4.07459e-05 6.451 0.455041 6 0.992041 6H19.008C19.556 6 20 6.449 20 7.007V19.993C20 20.549 19.545 21 19.008 21H11Z"
                fill="#2763CD" />
            </svg>
            &nbsp; Activate dual-monitor
          </li>
          <li (click)="createOutput()"><i class="fa fa-file-text-o"></i> Create output</li>
          <!-- <li (click)="createLetter()"><i class="fa fa-file-text-o"></i> Create recommendation letter</li> -->
          <!-- <li>
                    <i class="fa fa-cog"></i> Another action
                </li> -->
        </ul>

        <ul class="nav-actions gray">
          <li>
            <a (click)="pannel = 'filters'">
              <i class="fa fa-filter" *ngIf="!nActiveFilters"></i>
              <span class="n-filters" *ngIf="nActiveFilters">{{ nActiveFilters }}</span>
              Filter your views <i class="fa fa-chevron-right arrow"></i
            ></a>
          </li>
        </ul>

        <ul class="nav-actions gray" *ngIf="canOpenFlagManager && currentView != 'flagManager'">
          <li>
            <a
              style="color: #000; text-decoration: none"
              (click)="open = false"
              [routerLink]="'/inspection/review/flagManager/' + inspection.id"
              queryParamsHandling="merge"
              [queryParams]="{
                currentImage: undefined,
                item: undefined,
                section: undefined,
                question: undefined,
                right: undefined
              }">
              <i class="fa fa-flag"></i>

              Flags manager

              <i class="fa fa-chevron-right arrow"></i>
              <div
                class="progress"
                style="display: inline-flex; width: 45px; margin: 9px 10px 0 0; height: 5px; float: right">
                <div class="progress-bar" role="progressbar" [ngStyle]="{ width: flagsProgress + '%' }"></div>
              </div>
              <span style="float: right; margin-right: 10px">{{ flagsProgress }}%</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="nav-panel filters" *ngIf="pannel == 'filters'" [perfectScrollbar] (scroll)="$event.preventDefault()">
      <div class="title">
        <button class="btn btn-link" style="padding-left: 0" (click)="pannel = 'main'">
          <i style="margin-right: 15px" class="fa fa-chevron-left"></i>Back
        </button>

        <span style="color: #7f8eaa; margin-top: 6px; font-weight: 500; float: right">
          Currently applied <span class="n-filters" style="margin: 0 20px 0 10px">{{ nActiveFilters }}</span>
        </span>

        <h5>Filter your views</h5>
      </div>
      <div class="content">
        <div class="shortcuts">
          <button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-questions', disabled: currentView == 'flagManager' }"
            (click)="shortcut = 'all-questions'">
            All questions</button
          ><button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-mandatory-or-scored', disabled: currentView == 'flagManager' }"
            (click)="shortcut = 'all-mandatory-or-scored'">
            All Mandatory or Scored</button
          ><button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-flagged' }"
            (click)="shortcut = 'all-flagged'">
            All Flagged</button
          ><button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'auto-scored' }"
            (click)="shortcut = 'auto-scored'">
            Only auto-scored</button
          ><button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-unreviewed', disabled: currentView == 'flagManager' }"
            (click)="shortcut = 'all-unreviewed'">
            All Unreviewed</button
          ><button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-rejected', disabled: currentView == 'flagManager' }"
            (click)="shortcut = 'all-rejected'">
            All Rejected
          </button>
          <button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'all-unanswered', disabled: currentView == 'flagManager' }"
            (click)="shortcut = 'all-unanswered'">
            Only without answers
          </button>
          <button
            class="btn"
            type="button"
            [ngClass]="{ active: shortcut == 'only-with-extension', disabled: currentView != 'flagManager' }"
            (click)="shortcut = 'only-with-extension'">
            Only with extension
          </button>
        </div>

        <div class="dropdowns">
          <span>Flag type</span>
          <select
            class="form-control mt-0"
            [(ngModel)]="filters.flags"
            (change)="detailChanged()"
            [disabled]="isFlagTypeDisabled()">
            <option value="all">All</option>
            <option *ngFor="let st of this.flags" [ngValue]="st.subtypes">{{ st.name }}</option>
          </select>

          <span>Item type</span>
          <ng-select
            [items]="items"
            [multiple]="true"
            bindLabel="label"
            groupBy="allItemsGroup"
            (search)="onSearchItems($event)"
            (keydown.enter)="$event.stopImmediatePropagation(); onEnterItems()"
            [selectableGroup]="true"
            [selectableGroupAsModel]="false"
            [closeOnSelect]="false"
            [disabled]="currentView == 'flagManager'"
            (change)="detailChanged()"
            (ngModelChange)="itemChanged($event)"
            [clearable]="false"
            bindValue="label"
            [(ngModel)]="filters.items">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="items-container" *ngIf="items.length === 1">
                <div class="ng-value" *ngFor="let item of items">
                  <span class="ng-value-label">{{
                    item.label?.length > 30 ? item.label.substr(0, 30) + '...' : item.label
                  }}</span>
                </div>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{ items.length }} items selected</span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> All Items
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.label }}
            </ng-template>
          </ng-select>

          <span>Section type</span>
          <ng-select
            [items]="sections"
            [multiple]="true"
            bindLabel="name"
            groupBy="allSectionsGroup"
            (search)="onSearchSections($event)"
            (keydown.enter)="$event.stopImmediatePropagation(); onEnterSections()"
            [selectableGroup]="true"
            [selectableGroupAsModel]="false"
            [closeOnSelect]="false"
            [disabled]="currentView == 'flagManager'"
            (change)="detailChanged()"
            (ngModelChange)="sectionChanged()"
            [clearable]="false"
            bindValue="id"
            [(ngModel)]="filters.sections">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="items-container" *ngIf="items.length === 1">
                <div class="ng-value" *ngFor="let section of items">
                  <span class="ng-value-label">{{
                    section.name?.length > 30 ? section.name.substr(0, 30) + '...' : section.name
                  }}</span>
                </div>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{ items.length }} sections selected</span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> All Sections
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.name }}
            </ng-template>
          </ng-select>

          <span>Question Tags</span>
          <ng-select
            [items]="questionTags"
            [multiple]="true"
            bindLabel="name"
            groupBy="allQuestionTagsGroup"
            (search)="onSearchQuestionTags($event)"
            (keydown.enter)="$event.stopImmediatePropagation(); onEnterQuestionTags()"
            [selectableGroup]="true"
            [selectableGroupAsModel]="false"
            [closeOnSelect]="false"
            [disabled]="currentView == 'flagManager'"
            (change)="detailChanged()"
            (ngModelChange)="questionTagsChanged()"
            [clearable]="false"
            bindValue="id"
            [(ngModel)]="filters.questionTags"
            class="third-child">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="items-container" *ngIf="items.length === 1">
                <div class="ng-value" *ngFor="let tag of items">
                  <span class="ng-value-label">{{
                    tag.name?.length > 30 ? tag.name.substr(0, 30) + '...' : tag.name
                  }}</span>
                </div>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{ items.length }} question tags selected</span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> All Question Tags
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.name }}
            </ng-template>
          </ng-select>
          <button class="btn btn-link pl-0" *ngIf="!showOtherFilters" (click)="showOtherFilters = !showOtherFilters">
            Show more
          </button>
          <div *ngIf="showOtherFilters">
            <select
              class="form-control"
              [disabled]="currentView != 'gallery'"
              [(ngModel)]="filters.sorting"
              (change)="detailChanged()">
              <option value="followConfigurationOrder">Follow Configuration Order</option>
              <option value="asc">Date ascending</option>
              <option value="desc">Date descending</option>
            </select>

            <select
              class="form-control"
              [(ngModel)]="filters.questions"
              (change)="detailChanged()"
              [disabled]="currentView == 'flagManager'">
              <option value="all">All questions</option>
              <option *ngIf="scoresEnabled" value="mandatoryOrScored">Mandatory or Scored</option>
              <option value="mandatory">Mandatory</option>
              <option *ngIf="scoresEnabled" value="scored">Scored</option>
              <option *ngIf="scoresEnabled" value="autoScored">Auto-scored</option>
            </select>

            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox1"
                type="checkbox"
                [disabled]="currentView == 'flagManager'"
                [(ngModel)]="filters.withoutFlags"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox1">Without Flags</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox2"
                type="checkbox"
                [disabled]="currentView == 'flagManager'"
                [(ngModel)]="filters.withoutComments"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox2">Without Comments</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox3"
                type="checkbox"
                [(ngModel)]="filters.unreviewed"
                [disabled]="currentView == 'flagManager'"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox3">Unreviewed</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox4"
                type="checkbox"
                [(ngModel)]="filters.accepted"
                [disabled]="currentView == 'flagManager'"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox4">Accepted</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox5"
                type="checkbox"
                [(ngModel)]="filters.rejected"
                [disabled]="currentView == 'flagManager'"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox5">Rejected</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox6"
                type="checkbox"
                [(ngModel)]="filters.withAnswers"
                [disabled]="currentView == 'flagManager'"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox6">With answers</label>
            </div>
            <div class="form-check checkbox">
              <input
                class="form-check-input"
                id="checkbox7"
                type="checkbox"
                [(ngModel)]="filters.withDeadlineExtension"
                [disabled]="currentView != 'flagManager'"
                (change)="detailChanged()" />
              <label class="form-check-label" for="checkbox7">With deadline extension</label>
            </div>
          </div>
        </div>
        <button class="btn btn-link mt-4 pl-0" *ngIf="showOtherFilters" (click)="showOtherFilters = !showOtherFilters">
          Show less
        </button>
        <div class="buttons">
          <button class="btn aru" (click)="clearFilters()" [disabled]="currentView == 'flagManager'">Clear</button>
          <button class="btn btn-primary aru" (click)="applyFilters()">Apply</button>
        </div>
      </div>
    </div>
  </div>
</div>
